import { ChangeDetectionStrategy, Component, inject, input, InputSignal } from '@angular/core';
import { MatAnchor, MatButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { IconComponent } from '@libs/components/icons';
import type { SrmTicketModel } from '@libs/services/models';
import { LuxonDatePipe } from '@libs/shared/ui';
import { SrmHelperService } from '../../srm-helper.service';
import { SrmTicketLinkDirective } from '../../srm-ticket-link';
import { SrmTicketStatusComponent } from '../../srm-ticket-status';

@Component({
  selector: 'ui-srm-ticket-list-mobile',
  templateUrl: './srm-ticket-list-mobile.component.html',
  styleUrls: ['./srm-ticket-list-mobile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    IconComponent,
    SrmTicketLinkDirective,
    SrmTicketStatusComponent,
    LuxonDatePipe,
    MatTooltip,
    MatButton,
    MatAnchor,
  ],
})
export class SrmTicketListMobileComponent {
  public readonly helperService: SrmHelperService = inject(SrmHelperService);
  public tickets: InputSignal<SrmTicketModel[]> = input.required();
}
